import { J as BaseSort } from "./ViewModelPropertyBase-CtmPXiyw.js";
import { createPlugin } from "seroval";
// src/snapshot/plugins/base.ts
function createSerializationPlugin(plugin) {
	return createPlugin({
		tag: plugin.tag,
		test(value) {
			return plugin.test(value);
		},
		parse: { sync(value, ctx) {
			return plugin.serialize(value, { serialize: ctx.parse.bind(ctx) });
		} },
		deserialize(node, ctx) {
			return plugin.deserialize(node, { deserialize: ctx.deserialize.bind(ctx) });
		},
		serialize() {
			throw new Error("Not implemented");
		}
	});
}
function getViewModelPath(viewModel) {
	const path = [];
	let currentViewModel = viewModel;
	while (currentViewModel.parentRelation && currentViewModel.parentViewModel) {
		path.unshift(currentViewModel.parentRelation.name);
		currentViewModel = currentViewModel.parentViewModel;
	}
	return path;
}
function getViewModelByPath(viewModel, path) {
	let currentViewModel = viewModel;
	for (const segment of path) currentViewModel = currentViewModel.getSubViewModel(segment);
	return currentViewModel;
}
// src/snapshot/plugins/custom.ts
var customPluginFn;
function registerCustomSerializationPlugins(fn) {
	customPluginFn = fn;
}
function loadCustomPlugins() {
	return customPluginFn?.() ?? [];
}
// src/sorting/ExpressionSort.ts
/**
* Represents a sort based on an OData expression.
*/
var ExpressionSort = class extends BaseSort {
	/**
	* Initializes a new instance of the ExpressionSort class.
	* @param expression - The OData expression.
	*/
	constructor(expression) {
		super();
		this._expression = expression;
	}
	/**
	* Gets the OData expression.
	* @returns The OData expression.
	*/
	get expression() {
		return this._expression;
	}
	/**
	* Gets the string representation of the sort
	* @returns The string representation of the sort.
	*/
	toString() {
		return this.expression;
	}
	/**
	* Converts the sort to an OData string.
	* @returns The OData string.
	*/
	toODataString() {
		return this.expression;
	}
};
export { getViewModelByPath as a, createSerializationPlugin as i, loadCustomPlugins as n, getViewModelPath as o, registerCustomSerializationPlugins as r, ExpressionSort as t };

//# sourceMappingURL=ExpressionSort-gnltkjJF.js.map